export function uuid() {
  // @ts-ignore
  var crypto = window!.crypto! || window!.msCrypto!;

  if (crypto && crypto.getRandomValues) {
    // @ts-ignore
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c: any) =>
      // @ts-ignore
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  } else {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c: any) => {
      let r = (Math.random() * 16) | 0;
      let v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}

export function addTokenParameterIfInCurrentUrl(link) {
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("token")) {
    let token = urlParams.get("token")!;
    return addTokenParameter(link, token);
  } else {
    return link;
  }
}

export function addTokenParameter(link, token) {
  let url = new URL(link, window.location.origin);
  let hash = url.hash;
  let searchParams = new URLSearchParams(url.search);

  let count = 0;
  // @ts-ignore
  searchParams.forEach(() => {
    count++;
  });

  let baseLink = link.replace(hash, "");
  if (searchParams.get("token")) {
    baseLink = baseLink
      .replace("?token=" + searchParams.get("token"), "")
      .replace("&token=" + searchParams.get("token"), "");
    count--;
  }

  if (count > 0) {
    return baseLink + `&token=${token}` + hash;
  } else {
    return baseLink + `?token=${token}` + hash;
  }
}

export function parsePlaceholderText(text: string, start: string, end: string) {
  let startPos =
    text.indexOf(start) > -1 ? text.indexOf(start) + start.length : 0;
  let endPos =
    text.indexOf(end) > -1
      ? text.indexOf(end) - startPos
      : text.length - startPos;

  return text.substr(startPos, endPos);
}

export function scrollToElementId(id) {
  let target = document.getElementById(id);

  if (target) {
    // is Anker in Tab?
    let tabParent = closest(
      target,
      (el) => el.classList && el.classList.contains("mgs-tabs")
    );
    if (tabParent) {
      let tabNameElement = closest(target, (el) =>
        el.hasAttribute("data-tab-name")
      );
      if (tabNameElement) {
        let tabName = tabNameElement.getAttribute("data-tab-name");
        tabParent.__vue__.handleActiveTabChange(tabName);
      }
      setTimeout(() => {
        window.scroll({
          top: scrollOffset(target),
          left: 0,
          behavior: "smooth",
        });
      }, 400);
    } else {
      window.scroll({ top: scrollOffset(target), left: 0, behavior: "smooth" });
    }
  }
}

function scrollOffset(elem) {
  let header = document.getElementsByClassName("mgs-header");
  let padding = 0;
  if (header.length > 0) {
    padding = (<HTMLElement>header[0]).offsetHeight;
  }
  return offset(elem).top - padding;
}

export function offset(elem: HTMLElement) {
  if (!elem.getClientRects().length) {
    return { top: 0, left: 0 };
  }

  let rect = elem.getBoundingClientRect();
  let win = elem.ownerDocument!.defaultView!;
  return {
    top: rect.top + win.pageYOffset,
    left: rect.left + win.pageXOffset,
  };
}

function closest(el, predicate) {
  do if (predicate(el)) return el;
  while ((el = el && el.parentNode));
}

export function debounce(func: Function, timeout: number) {
  let timer: NodeJS.Timeout;
  return (...args: any) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func(...args);
    }, timeout);
  };
}

export function throttle(func, limit) {
  var inThrottle, lastFunc, lastRan;

  return function () {
    // @ts-ignore
    var context = this;
    var args = arguments;

    if (!inThrottle) {
      func.apply(context, args);
      lastRan = Date.now();
      inThrottle = true;
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function deleteCookie(cname) {
  document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}
